import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import API_BASE_URL from '../config';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        try {

            const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
                email: email, 
                password: password
            });

            console.log("Response:", response.data);
            
            // ✅ Lưu token
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
            }

            // 🔥 FIX QUAN TRỌNG: lưu user
            if (response.data.user) {
                localStorage.setItem('user', JSON.stringify(response.data.user));
            }

            // Xử lý điều hướng theo role
            let role = response.data.user?.role;

            // normalize
            if (typeof role === 'number') role = String(role);
                role = role?.toLowerCase().trim();

            if (role === 'admin' || role === '1') {
                navigate('/admin/dashboard');
            } 
            else if (role === 'user' || role === '2') {
                navigate('/admin/dashboard');
            } 
            else if (role === 'student' || role === '3') {
                navigate('/dashboard');
            } 
            else {
                navigate('/dashboard');
            }
            
        } catch (err) {
            console.error("Lỗi đăng nhập:", err.response?.data);
            alert(err.response?.data?.message || "Đăng nhập thất bại. Vui lòng thử lại!");
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src="/images/logo.jpg" alt="Logo" className="login-logo" />
                <h2>WELCOME!</h2>
                <form onSubmit={handleLogin}>
                    <input 
                        type="email" 
                        placeholder="Email" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                    />
                    <input 
                        type="password" 
                        placeholder="Password" 
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} 
                        required 
                    />
                    <button type="submit" className="login-btn">LOGIN</button>
                </form>
                <p className="footer-text">Each student is given a separate account!</p>
            </div>
        </div>
    );
};

export default Login;